import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import EditIcon from '@material-ui/icons/Edit';
import { IconButton } from '@material-ui/core';

const useStyles = makeStyles(() => ({
    editButton: {
        position: 'absolute',
        padding: '6px',
        transform: 'translate(25%, -3px)',
    },
    editIcon: {
        fontSize: '1.1rem',
    },
}));

const EditButton = React.memo(({ clickHandler, ...props }) => {
    const classes = useStyles();

    return (
        <IconButton
            className={classes.editButton}
            color="primary"
            onClick={clickHandler}
            {...props}
        >
            <EditIcon className={classes.editIcon} />
        </IconButton>
    );
});

export default EditButton;